<template>
  <div class="card-orcamento-informacao">
    <div class="conteudo-card-orcamento">
      <g-card :temCabecalho="false" :expansivel="false" margem="0" paddingDefault="0">
        <div class="conteudo-card-orcamento-informacao">  
          <div class="content-grupo">
            <div class="template-pagina">
              <div class="imagem-template-cabecalho">
                <img src="@/assets/imgs/Cabecalho_Orcamento.svg" class="img-cabecalho">
              </div>

              <div class="imagem-template-rodape">
                <img src="@/assets/imgs/Rodape_Orcamento_inicio.svg" class="img-rodape">
              </div>
            </div>    

            <div class="container-parametros-cliente-loteFrete grupo-primeiraPag">
              <div class="unidade-representante">
                <div class="titulo-conteudo-cabecalho"> Representante: &nbsp; <div class="label-cabecalho">{{nomeRepresentante}}</div></div>
                <div class="titulo-conteudo-cabecalho"> Unidade: &nbsp; <div class="label-cabecalho">{{nomeEmpresa}}</div></div>
              </div>

              <div class="cards-parametros-cliente">
                <div class="parametros">          
                  <div class="borda-titulo-grupo">
                    <div class="titulo-grupo"> PARÂMETROS </div>
                    <div class="borda-grupo"></div>
                  </div>

                  <div class="grupo-parametros">
                    <div class="parametros-numero-solicitacao">
                      <div class="titulo-conteudo-detalhes"> Nº Solicitação </div>
                      <div class="label-conteudo">{{ numeroSolicitacao }}</div>
                    </div>

                    <div class="parametros-status">
                      <div class="titulo-conteudo-detalhes"> Status </div>
                      <div class="label-conteudo">{{ statusText }}</div>
                    </div>

                    <div class="parametros-unidade">
                      <div class="titulo-conteudo-detalhes"> Unidade </div>
                      <div class="label-conteudo">{{ nomeEmpresa }}</div>
                    </div>

                    <div class="parametros-data-digitacao">
                      <div class="titulo-conteudo-detalhes"> Data Digitação </div>
                      <div class="label-conteudo">{{ dataDigitacaoFormatadaConsulta }}</div>
                    </div>

                    <div class="parametros-data-retorno">
                      <div class="titulo-conteudo-detalhes"> Data Retorno </div>
                      <div class="label-conteudo">{{ dataAlteracao }}</div>
                    </div>
                    
                    <div class="parametros-representante">
                      <div class="titulo-conteudo-detalhes"> Representante </div>
                      <div class="label-conteudo">{{ nomeRepresentante }}</div>
                    </div>
                  </div>
                </div>

                <div class="cliente">
                  <div class="borda-titulo-grupo">
                    <div class="titulo-grupo"> CLIENTE </div>
                    <div class="borda-grupo"></div>
                  </div>

                  <div class="grupo-cliente">
                    <div class="cliente-cnpj">
                      <div class="titulo-conteudo-detalhes"> CNPJ </div>
                      <div class="label-conteudo">{{ cnpj }}</div>
                    </div>

                    <div class="cliente-codigo">
                      <div class="titulo-conteudo-detalhes"> Código </div>
                      <div class="label-conteudo">{{ codigoUsuario }}</div>
                    </div>

                    <div class="cliente-telefone">
                      <div class="titulo-conteudo-detalhes"> Telefone </div>
                      <div class="label-conteudo">{{ numeroTelefone || numeroCelular }}</div>
                    </div>

                    <div class="cliente-razao-social">
                      <div class="titulo-conteudo-detalhes"> Razão Social </div>
                      <div class="label-conteudo">{{ razaoSocial }}</div>
                    </div>

                    <div class="cliente-cidade">
                      <div class="titulo-conteudo-detalhes"> Cidade </div>
                      <div class="label-conteudo">{{ nomeCidade }}</div>
                    </div>

                    <div class="cliente-estado">
                      <div class="titulo-conteudo-detalhes"> Estado </div>
                      <div class="label-conteudo">{{ siglaEstado }}</div>
                    </div>

                    <div class="cliente-segmento">
                      <div class="titulo-conteudo-detalhes"> Segmento </div>
                      <div class="label-conteudo">{{ segmentoFormat }}</div>
                    </div>

                    <div class="cliente-contato">
                      <div class="titulo-conteudo-detalhes"> Contato </div>
                      <div class="label-conteudo">{{ nomeContato || "Não cadastrado" }}</div>
                    </div>

                    <div class="cliente-ramal" v-if="this.numeroRamal == 0">
                      <div class="titulo-conteudo-detalhes"> Ramal </div>
                      <div class="label-conteudo">{{ numeroRamal || "Não Possui" }}</div>
                    </div>

                    <div class="cliente-suframa" v-if="this.numeroSuframa == 0">
                      <div class="titulo-conteudo-detalhes"> Suframa </div>
                      <div class="label-conteudo">{{ numeroSuframa }}</div>
                    </div>

                    <div class="cliente-incentivo-fiscal">
                      <div class="titulo-conteudo-detalhes"> Possui incentivo fiscal? </div>
                      <div class="label-conteudo">
                        {{
                          icms + ipi + piscofins == "" ? "NÃO" : icms + ipi + piscofins
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>      

              <div class="borda-titulo-grupo titulo-infoBasicas">
                <div class="titulo-grupo"> INFORMAÇÕES BÁSICAS </div>
                <div class="borda-grupo"></div>
              </div>

              <div class="grupo-infoBasicas">
                <div class="box-infoBasicas">
                  <div class="nome-quantidade-produto">
                    <div class="infoBasicas-nome-produto">
                      <div class="titulo-conteudo-detalhes"> Nome do Produto </div>
                      <div class="label-conteudo">{{ nomeProduto ? nomeProduto : "Produto Teste" }}</div>
                    </div>

                    <div class="infoBasicas-quantidade-data">
                      <div class="infoBasicas-quantidade">
                        <div class="titulo-conteudo-detalhes"> Quantidade </div>
                        <div
                          class="label-infoBasicas label-conteudo"
                          v-for="data in OrcaQuantidade"
                          :key="data.id"
                        >
                          {{ formataDecimal(data.quantidade) }}                  
                        </div>
                      </div>

                      <div class="infoBasicas-diaCarregamento">
                        <div class="titulo-conteudo-detalhes"> Dia Carregamento </div>
                        <div
                          class="label-infoBasicas label-conteudo"
                          v-for="data in OrcaQuantidadeDiaCarregamento"
                          :key="data.id"
                        >
                          {{data.dataCarregamentoFormato == 'N/A' ? '-' : data.dataCarregamentoFormato  }} 
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="infoBasicas-imagemProduto">
                    <div class="ilustracao-sem-imagem"> <!-- v-else -->
                      <!-- <img src="@/assets/imgs/Ilustra_sem_imagem.svg" /> -->
                      <div v-if="PropcaminhoImagem == 'https://fdv.grupojauense.com.br/repositorio/Ilustracao_Nenhuma_Img.svg'">
                        <img class="img-sem-imagem" :src="PropcaminhoImagem" />
                      </div>
                      <div v-if="PropcaminhoImagem != 'https://fdv.grupojauense.com.br/repositorio/Ilustracao_Nenhuma_Img.svg'">
                        <img class="img-sem-imagem" :src="PropcaminhoImagem" style="width: 200px" />
                      </div>                      
                      <div class="label-sem-ilustracao" v-if="PropcaminhoImagem == 'https://fdv.grupojauense.com.br/repositorio/Ilustracao_Nenhuma_Img.svg'"  > Sem imagem disponível! </div>
                      
                    </div>
                  </div>
                </div>

                <div class="infoBasicas-amostraRef">
                  <div class="label-infoBasicas2 titulo-conteudo-detalhes"> Deseja utilizar amostra de referência? </div>
                  
                  <div class="checkbox-filtros">
                    <div class="input-checkbox">
                      <PCheckBox
                        :binary="true"
                        v-model="OrcamentoAmostra"
                      ></PCheckBox>
                      <label class="label-checkbox" for="amostra"> Acompanha amostra </label>
                    </div>

                    <div class="input-checkbox">
                      <PCheckBox
                        :binary="true"
                        v-model="OrcamentoAmostraEspTecnica"
                      ></PCheckBox>
                      <label class="label-checkbox" for="especificacoes"> Todas as especificações técnicas conforme amostra </label>
                    </div>

                    <div class="input-checkbox">
                      <PCheckBox
                        :binary="true"
                        v-model="OrcamentoAmostraOutros"
                      ></PCheckBox>
                      <label class="label-checkbox" for="outros"> Outros materiais do cliente </label>
                    </div>

                    <div class="descricao-outros-materiais input-checkbox">
                      <label class="label-checkbox" for="outros-embalagens">{{OrcamentoAmostraDescOutros}}</label>
                    </div>
                  </div>
                </div>

                <div class="infoBasicas-observacao">
                  <!-- v-if="this.tipoFluxoOrcamento == 0 || this.tipoFluxoOrcamento == 2">             -->
                  <div class="label-infoBasicas2 titulo-conteudo-detalhes"> Observação sobre Quantidade  /  Carregamento  /  Consumo </div>
                  <div class="label-conteudo">{{ InformacaoObservacao ? InformacaoObservacao : "Não possui observação." }}</div>
                </div>
              </div>  
            </div>      
          </div>      

          <div class="html2pdf__page-break"/>

          <div class="content-grupo">
            <div class="container-base">
              <div class="contador-pag-componentes" v-for="e in Math.ceil(componentesLista.length / 4)" :key="e">
                <div class="template-pagina-comp">
                  <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                    <div class="titulo-conteudo-detalhes label-codigo-externo">#{{this.numeroSolicitacao}}</div>
                    <img src="@/assets/imgs/Cabecalho_Orcamento.svg" class="img-cabecalho">
                  </div>
                  
                  <div class="imagem-template-rodape espaco-data-rodape">
                    <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, {{ this.DiaHoje }} </div> 
                    <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-rodape">
                  </div>
                </div>
              </div>

              <div class="template-pagina-comp" v-if="!componentesLista.length > 0"> 
                <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                  <div class="titulo-conteudo-detalhes label-codigo-externo">#{{this.numeroSolicitacao}}</div>
                  <img src="@/assets/imgs/Cabecalho_Orcamento.svg" class="img-cabecalho">
                </div>
                
                <div class="imagem-template-rodape espaco-data-rodape">
                  <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, {{ this.DiaHoje }} </div> 
                  <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-rodape">
                </div>
              </div>
            </div>

            <div class="container-principal-componentes grupo">
              <div class="borda-titulo-grupo titulo-componentes">
                <div class="titulo-grupo"> COMPONENTES </div>
                <div class="borda-grupo"></div>
              </div>

              <div class="container-componentes" v-if="componentesLista.length > 0">
                <div v-for="(data, index) in componentesLista" :key="index">                                                    
                  <div class="box-componente" :class="(index + 1) > 4 ? 'box-comp-espacamento' : ''">
                    <div class="imagem-numero-nome-componente">
                      <div class="imagem-grupo-componente">
                        <img src="@/assets/imgs/icone_componente_orcamento.svg" class="img-componente">
                      </div>
                      
                      <div class="numero-nome-componente">
                        <div class="titulo-conteudo-detalhes numero-componente"> Componente {{ index + 1 }}</div>
                        <div class="nome-componente label-conteudo">{{ data.componenteTipoTexto }}</div>
                      </div>
                    </div> 

                    <div class="grupo-componentes">
                      <div class="componentes-medidas">
                        <div class="medidas titulo-conteudo-detalhes"> Medidas </div>
                        <div class="medidas label-conteudo">{{ (data.numeroComprimento != 0) && (data.numeroLargura != 0)   ? data.numeroComprimento + 'x' + data.numeroLargura + 'x' + data.numeroAltura + 'x' + data.numeroAlturaTampa : data.descricaoMedidasTexto }}</div>

                      </div>

                      <div class="componentes-cor-frente">
                        <div class="corFrente titulo-conteudo-detalhes"> Cor Frente </div>
                        <div class="corFrente label-conteudo">{{data.quantidadeCoresFrente != 1 ? data.quantidadeCoresFrente + ' Cores' : data.quantidadeCoresFrente + ' Cor'}} </div>
                        <!-- <div class="corFrente label-conteudo">{{data.quantidadeCoresFrente != 1 ? data.quantidadeCoresFrente + ' Cores' + '  ' + data.nomeCorFrente  : data.quantidadeCoresFrente + ' Cor' + '   ' + data.nomeCorFrente }} </div> -->
                      </div>

                      <div class="componentes-cor-verso">
                        <div class="corVerso titulo-conteudo-detalhes"> Cor Verso </div>
                        <div class="corVerso label-conteudo">{{data.quantidadeCoresVerso != 1 ? data.quantidadeCoresVerso + ' Cores' : data.quantidadeCoresVerso + ' Cor'}}</div>
                        <!-- <div class="corVerso label-conteudo">{{data.quantidadeCoresVerso != 1 ? data.quantidadeCoresVerso + ' Cores' +  '   ' +  data.nomeCorVerso : data.quantidadeCoresVerso + ' Cor'  + '  ' + data.nomeCorVerso}}</div> -->
                      </div>

                      <div class="componentes-acabFrente">
                        <div class="acabFrente titulo-conteudo-detalhes"> Acabamento Frente </div>
                        <div class="acabFrente label-conteudo">{{ data.descricaoAcabamentoFrenteTexto }}</div>
                      </div>

                      <div class="componentes-acabVerso">
                        <div class="acabVerso titulo-conteudo-detalhes"> Acabamento Verso </div>
                        <div class="acabVerso label-conteudo">{{ data.descricaoAcabamentoVersoTexto }}</div>
                      </div>

                      <div class="componentes-material">
                        <div class="material titulo-conteudo-detalhes"> Material </div>
                        <div class="material label-conteudo">{{ data.descricaoMaterialTexto }}</div>
                      </div>

                      <div class="componentes-onda">
                        <div class="onda titulo-conteudo-detalhes"> Onda </div>
                        <div class="onda label-conteudo">{{ data.descricaoOndaTexto }}</div>
                      </div>

                      <div class="componentes-capaExt">
                        <div class="capaExt titulo-conteudo-detalhes"> Capa Externa </div>
                        <div class="capaExt label-conteudo">{{ data.descricaoCapaExternaTexto }}</div>
                      </div>

                      <div class="componentes-capaInt">
                        <div class="capaInt titulo-conteudo-detalhes"> Capa Interna </div>
                        <div class="capaInt label-conteudo">{{ data.descricaoCapaInternaTexto }}</div>
                      </div>

                      <div class="componentes-papelOnda">
                        <div class="papelOnda titulo-conteudo-detalhes"> Papel de Onda </div>
                        <div class="papelOnda label-conteudo">{{ data.descricaoPapelOndaTexto }}</div>
                      </div>

                      <div class="componentes-descricao" v-if="data.descricaoSistema == 0">
                        <div class="desc-componente titulo-conteudo-detalhes"> Descrição do Sistema </div>
                        <div class="label-conteudo">{{ data.sistema }}</div>
                      </div>

                      <div class="componentes-produto" v-if="data.descricaoSistema == 2">
                        <div class="produto-comp titulo-conteudo-detalhes"> Produto </div>
                        <div class="label-conteudo">{{ data.produtoSistema }}</div>
                      </div>

                      <div class="componentes-prototipo" v-if="data.descricaoSistema == 3">
                        <div class="prototipo titulo-conteudo-detalhes"> Protótipo </div>
                        <div class="label-conteudo">{{ data.prototipoSistema }}</div>
                      </div>

                      <div class="componentes-embalagem-coletiva" 
                        v-if="data.embalagemPalete == true || 
                        data.embalagemFilmeEncolhivel == true || 
                        data.embalagemCaixaColetiva == true || 
                        data.embalagemPapelEmbrulho == true || 
                        data.quantidadeOutros != 0"
                      >
                        <div class="embalagem titulo-conteudo-detalhes"> Embalagem Coletiva </div>
                        <div class="labels-embalagem-coletiva">
                          <div class="label-conteudo" v-for="(texto, index) in data.embalagens" :key="index"
                          >{{ texto }}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="html2pdf__page-break" v-if="(index + 1) % 4 === 0 && (index + 1) != componentesLista.length"/>             
                </div>
              </div>

              <div class="label-conteudo label-sem-componentes" v-else> Não possui componentes. </div>
            </div>
          </div>
              
          <div class="html2pdf__page-break"/>     
          
          <div class="content-grupo">
            <div class="template-pagina">
              <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                <div class="titulo-conteudo-detalhes label-codigo-externo">#{{this.numeroSolicitacao}}</div>
                <img src="@/assets/imgs/Cabecalho_Orcamento.svg" class="img-cabecalho">
              </div>
              
              <div class="imagem-template-rodape espaco-data-rodape">
                <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, {{ this.DiaHoje }} </div> 
                <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-rodape">
              </div>
            </div>

            <div class="container-demaisCaract-infoBasicas grupo">
              <div class="container-infoBasicas">
                <div class="borda-titulo-grupo titulo-loteFrete">
                  <div class="titulo-grupo"> LOTE E FRETE </div>
                  <div class="borda-grupo"></div>
                </div>

                <div class="grupo-loteFrete">
                  <div class="imagem-grupo-loteFrete">
                    <img src="@/assets/imgs/icone_frete_orcamento.svg" class="img-loteFrete">
                  </div>

                  <div class="loteFrete-riscoFaca" v-if="this.tipoFluxoOrcamento == 0 || this.tipoFluxoOrcamento == 2">
                    <div class="titulo-conteudo-detalhes"> Risco Faca </div>
                    <div class="label-conteudo">{{ riscoFaca ? "Sim" : "Não" }}</div>
                  </div>

                  <div class="loteFrete-prototipo" v-if="this.tipoFluxoOrcamento == 0 || this.tipoFluxoOrcamento == 2">
                    <div class="titulo-conteudo-detalhes"> Protótipo </div>
                    <div class="label-conteudo">{{ prototipo ? "Sim" : "Não" }}</div>
                  </div>

                  <div class="loteFrete-frete">
                    <div class="titulo-conteudo-detalhes"> Frete </div>
                    <div class="label-conteudo">{{ freteEnum }}</div>
                  </div>    

                  <div class="loteFrete-tipo-frete">
                    <div class="titulo-conteudo-detalhes"> Tipo Frete </div>
                    <div class="label-conteudo">{{ tipoFreteEnum || "Não cadastrado" }}</div>
                  </div>

                  <div class="loteFrete-cep">
                    <div class="titulo-conteudo-detalhes"> CEP </div>
                    <div class="label-conteudo">{{ cep || "Não Cadastrado" }}</div>
                  </div>

                  <div class="loteFrete-cidade">
                    <div class="titulo-conteudo-detalhes"> Cidade </div>
                    <div class="label-conteudo">{{ nomeCidade }}</div>
                  </div>

                  <div class="loteFrete-estado">
                    <div class="titulo-conteudo-detalhes"> UF </div>
                    <div class="label-conteudo">{{ siglaEstado }}</div>
                  </div>  

                  <div class="loteFrete-lote">
                    <div class="titulo-conteudo-detalhes"> Lote </div>
                    <div class="label-conteudo">{{ informacaoLoteText }}</div>
                  </div>

                  <div class="loteFrete-descricao-lote">
                    <div class="titulo-conteudo-detalhes"> Descrição Lote </div>
                    <div class="lote label-conteudo">{{ DescricaoLote || "Não Possui" }}</div>
                  </div>

                  <div class="loteFrete-sequencia">
                    <div class="titulo-conteudo-detalhes"> Sequência </div>
                    <div class="label-conteudo">{{ getSequencia }}</div>
                  </div>

                  <div class="loteFrete-descricao-sequencia">
                    <div class="titulo-conteudo-detalhes"> Descrição Sequência </div>
                    <div class="label-conteudo">{{ OrcamentoDescricaoSequencia || "Não Possui" }}</div>
                  </div>
                </div>        
              </div>            

              <div class="container-demais-caracteristicas">
                <div class="borda-titulo-grupo titulo-demaisCaract">
                  <div class="titulo-grupo"> DEMAIS CARACTERÍSTICAS </div>
                  <div class="borda-grupo"></div>
                </div>

                <div class="grupo-demaisCaract">
                  <div class="demaisCaract-papel-seda">
                    <div class="titulo-conteudo-detalhes"> Papel de Seda </div>
                    <div class="checkbox-filtros">
                      <div class="input-checkbox">
                        <PCheckBox
                          :binary="true"
                          v-model="papelSeda"
                        ></PCheckBox>
                        <label class="label-checkbox">
                          Enviar Papel de Seda
                        </label>
                      </div>

                      <div class="input-checkbox" v-if="papelSeda">
                        <label class="label-checkbox">
                          {{ medidaPapelSeda }} X {{ medidaPapelSeda2 }}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="demaisCaract-gerais">
                    <div class="titulo-conteudo-detalhes"> Gerais </div>
                    <div class="checkbox-filtros">
                      <div class="input-checkbox">
                        <PCheckBox
                          :binary="true"
                          v-model="OrcamentoGeraisFsc"
                        ></PCheckBox>
                        <label class="label-checkbox" for="FSC">
                          Cliente exige selo FSC nesse produto
                        </label>
                      </div>

                      <div class="input-checkbox">
                        <PCheckBox
                          :binary="true"
                          v-model="OrcamentoGeraisLegislacao"
                        ></PCheckBox>
                        <label class="label-checkbox" for="legislacao">
                          Existe legislação ou requisito regulamentar específico
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="demaisCaract-embalagem">
                    <div class="titulo-conteudo-detalhes"> Embalagem coletiva específica </div>                  
                    <div class="checkbox-filtros">
                      <div class="input-checkbox">
                        <PCheckBox
                          :binary="true"
                          v-model="OrcamentoEmbalagemFilme"
                        ></PCheckBox>
                        <label class="label-checkbox" for="filme-encolhivel">
                          Filme encolhível
                        </label>
                      </div>

                      <div class="input-checkbox">
                        <PCheckBox
                          :binary="true"
                          v-model="OrcamentoEmbalagemCaixaColetiva"
                        ></PCheckBox>
                        <label class="label-checkbox" for="caixa-coletiva"
                        >
                          Caixa coletiva
                        </label>
                      </div>

                      <div class="input-checkbox">
                        <PCheckBox
                          :binary="true"
                          v-model="OrcamentoEmbalagemPalete"
                        ></PCheckBox>
                        <label class="label-checkbox" for="palete"> Palete </label>
                      </div>

                      <div v-if="OrcamentoEmbalagemPalete" class="input-checkbox">
                        <PCheckBox :binary="true" v-model="MelhorAproveitamento"/>
                        <label class="label-checkbox"> Melhor Aproveitamento </label>
                      </div>

                      <div v-if="OrcamentoEmbalagemPalete" class="input-checkbox">
                        <label class="label-checkbox"> C: {{ComprimentoPalete}} X L: {{LarguraPalete}} X A: {{AlturaPalete}} </label>
                      </div>

                      <div v-if="OrcamentoEmbalagemPalete" class="input-checkbox">
                        <label class="label-checkbox"> Obs. Palete: {{ObservacaoPalete}} </label>
                      </div>

                      <div class="input-checkbox">
                        <PCheckBox
                          :binary="true"
                          v-model="OrcamentoEmbalagemOutros"
                        ></PCheckBox>
                        <label class="label-checkbox" for="embalagem-outros"
                        >
                          Outros
                        </label>
                      </div>

                      <div class="descricao-outros-embalagens input-checkbox">
                        <label
                          class="label-checkbox"
                          for="descricao-outros-embalagens"
                        >
                          {{ OrcamentoEmbalagemDescOutros }}
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="demaisCaract-critica">
                    <div class="titulo-conteudo-detalhes"> Crítica de processo </div>
                    <div class="checkbox-filtros">
                      <div class="input-checkbox critica-container">
                        <label class="label-checkbox" for="fechamento-maquina">
                          O produto terá fechamento por máquina por parte do cliente?
                        </label>
                        <label :class="`label-checkbox critica-bool ${OrcamentoCritica3 ? 'botao-positivo' : 'botao-negativo'}`" for="fechamento-maquina">
                          {{ OrcamentoCritica3 ? "SIM" : "NÃO" }}
                        </label>
                      </div>
                    </div>
                  </div>      
                </div>
              </div>
            </div>
          </div> 

          <div class="html2pdf__page-break" />  

          <div class="content-grupo">
            <div class="template-pagina">
              <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                <div class="titulo-conteudo-detalhes label-codigo-externo">#{{this.numeroSolicitacao}}</div>
                <img src="@/assets/imgs/Cabecalho_Orcamento.svg" class="img-cabecalho">
              </div>
              
              <div class="imagem-template-rodape espaco-data-rodape">
                <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, {{ this.DiaHoje }} </div> 
                <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-rodape">
              </div>
            </div>
         
            <div class="grupo-info-orcamentos grupo">
              <div class="borda-titulo-grupo titulo-orcamentos">
                <div class="titulo-grupo"> ORÇAMENTOS </div>
                <div class="borda-grupo"></div>
              </div>

              <div class="grupo-orcamento">
                <div class="orcamento-porcentagem-financeira">
                  <div class="titulo-conteudo-detalhes"> % Financeira </div>
                  <div class="label-conteudo">{{ porcentagemFinanceira }}%</div>
                </div>

                <div class="orcamento-forma-pagamento">
                  <div class="titulo-conteudo-detalhes"> Forma de Pagamento </div>
                  <div class="label-conteudo">{{ formaPagamento }}</div>
                </div>

                <div class="orcamento-data-hora">
                  <div class="titulo-conteudo-detalhes"> Data / Hora </div>
                  <div class="label-conteudo">{{ dataEHora }}</div>
                </div>

                <div class="orcamento-prazo-maximo">
                  <div class="titulo-conteudo-detalhes"> Prazo máximo </div>
                  <div class="label-conteudo">{{ prazoMaximo }}</div>
                </div>


                <div class="orcamento-gramatura">
                  <div class="titulo-conteudo-detalhes"> Gramatura </div>
                  <div class="label-conteudo">{{ gramatura }}</div>
                </div>
              </div>

              <div class="orcamento-tabela">
                <div class="orcamento-tabela-conteudo">
                  <div class="cabecalho-tabela">
                    <div class="titulo-conteudo-detalhes titulo-tabela"> Quantidade </div>
                    <div class="titulo-conteudo-detalhes titulo-tabela"> Preço </div>
                    <div class="titulo-conteudo-detalhes titulo-tabela"> Comissão </div>
                  </div>
                  
                  <div 
                    class="informacao-tabela" 
                    v-for="(data, index) in quantidadePrecoArray"
                    :key="index"
                  >
                    <div :class="`info-conteudo ${index % 2 === 0 ? 'pinta-linha' : 'nao-pinta-linha' }`">
                      <div class="label-conteudo label-tabela">{{ formataDecimal(data.quantidade) }}</div>
                      <div class="label-conteudo label-tabela">{{ formataMonetario(data.preco) }}</div>
                      <div class="label-conteudo label-tabela">{{ data.comissao }}%</div>

                      <div class="html2pdf__page-break" v-if="index === 10"/>  
                    </div>
                  </div>
                </div>
              </div>
            </div> 
          </div>                  
          <div class="html2pdf__page-break" />  
        </div>
      </g-card>
    </div>
  </div>
</template>
      
<script>
import ConsultarOrcamentoPDF from "./ConsultarOrcamentoPDF.js";
export default ConsultarOrcamentoPDF;
</script>
  
<style scoped>
.content-grupo {
  position: relative;
  height: 100%;
}
.template-pagina {
  position: absolute;
  height: 70.125rem;
  width: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1000;
}
.imagem-template-cabecalho {
  display: flex;
  align-items: flex-start;
}
.imagem-template-rodape {
  position: relative;
  display: flex;
  align-items: flex-end;
}
.img-cabecalho, .img-rodape {
  width: 99.25%;
}

.espaco-codigo-externo-cabecalho {
  position: relative;
}

.label-codigo-externo {
  position: absolute;
  height: 100%;
  width: 99.25%;
  color: #4f2c19 !important;
  font-size: 0.9rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.08rem;
  display: flex;
  align-items: center;
  top: 0;
  left: 0;
  padding: 0 0 0.2rem 9.6rem;
  z-index: 1000;
}

.espaco-data-rodape {
  position: relative;
}
.data-rodape {
  color: #fff !important;
  font-size: 0.75rem !important;
  font-weight: 500;
  position: absolute;
  height: 100%;
  width: 99.25%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  left: 0;
  padding: 0.35rem 1.5rem 0.3rem 0;
  z-index: 1000;
}

.unidade-representante {
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
  margin-bottom: 3rem;
}

.cards-parametros-cliente-loteFrete {
  width: 99.25%;
}

.cards-parametros-cliente {
  display: grid;
  column-gap: 1.5rem;
  width: 45.5rem;
  grid-template-columns: minmax(4rem, 1.6fr) minmax(4rem, 2fr);
  grid-template-rows: auto;
  margin-bottom: 3rem;
}

.parametros, .cliente {
  background-color: #F9F9F9;
  height: auto;
  padding: 1rem 1rem 0.5rem;
  border-radius: 0.5rem;
  flex-grow: 1;
}

.grupo-primeiraPag, .grupo {
  position: absolute;
  padding: 2rem 2rem 0;
}
.grupo-primeiraPag {
  margin-top: 4rem;
}
.grupo {
  margin-top: 3rem;
}

.borda-titulo-grupo {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 0.8rem;
}

.titulo-grupo {
  width: 100%;
  color: #4f2c19;
  text-align: left;
  font-size: 1.1rem;
  font-family: "MontSerrat";
  font-weight: 700;
  padding-bottom: 0.3rem;
  letter-spacing: 1px;
}

.titulo-grupo-espacamento {
  margin-top: 5rem;
}

.borda-grupo {
  width: 5rem;
  height: 3px;
  background-color: #FCB315;
}

.titulo-conteudo-detalhes {
  color: #3f3f3f;
  font-size: 0.8rem;
  margin-top: 0.1rem;
}
.label-conteudo {
  font-size: 0.8rem;
}

.grupo-parametros .titulo-conteudo-detalhes, .grupo-cliente-t1 .titulo-conteudo-detalhes, .grupo-cliente-t2 .titulo-conteudo-detalhes {
  margin-top: 0.5rem;
}

.grupo-parametros, .grupo-cliente {
  display: grid;
  column-gap: 1rem;
}

.grupo-parametros {
  grid-template-columns: repeat(2, minmax(4rem, 1fr));
  grid-template-rows: repeat(4, auto);
}
.parametros-numero-solicitacao { grid-area: 1 / 1 / 2 / 2; }
.parametros-status { grid-area: 1 / 2 / 2 / 3; }
.parametros-unidade { grid-area: 2 / 1 / 3 / 3; }
.parametros-data-digitacao { grid-area: 3 / 1 / 4 / 2; }
.parametros-data-retorno { grid-area: 3 / 2 / 4 / 3; }
.parametros-representante { grid-area: 4 / 1 / 5 / 3; }

.grupo-cliente {
  grid-template-columns: max-content repeat(2, 1fr);
  grid-auto-rows: auto;
}
.cliente-cnpj { grid-area: 1 / 1 / 2 / 2; }
.cliente-codigo { grid-area: 1 / 2 / 2 / 3; }
.cliente-telefone { grid-area: 1 / 3 / 2 / 4; }
.cliente-razao-social { grid-area: 2 / 1 / 3 / 4; }
.cliente-cidade { grid-area: 3 / 1 / 4 / 3; }
.cliente-estado { grid-area: 3 / 3 / 4 / 4; }
.cliente-segmento { grid-area: 4 / 1 / 5 / 3; }
.cliente-contato { grid-area: 4 / 3 / 5 / 4; }
.cliente-incentivo-fiscal { grid-column: span 2; }

.titulo-loteFrete {
  position: absolute;
  z-index: 10000;
  margin-top: 1.5rem;
}

.grupo-loteFrete {
  display: grid;
  grid-template-columns: 12rem auto repeat(3, minmax(4rem, 1fr));
  grid-template-rows: repeat(4, minmax(4rem, max-content));
  grid-column-gap: 2rem;
  grid-row-gap: 0;
  position: relative;
  margin: 4.5rem 0 0 1rem;
}

.imagem-grupo-loteFrete { 
  grid-area: 1 / 1 / 3 / 2; 
  height: 80%;
  display: flex;
  align-content: flex-start;
  position: relative;
}
.img-loteFrete {
  height: 100%;
  width: 90%;
}
.loteFrete-lote { grid-area: 3 / 1 / 4 / 2; }
.loteFrete-descricao-lote { grid-area: 3 / 2 / 4 / 5; }
.loteFrete-sequencia { grid-area: 4 / 1 / 5 / 2; }
.loteFrete-descricao-sequencia { grid-area: 4 / 2 / 5 / 5; }

.labels-embalagem-coletiva {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.5rem;
  width: 100%;
}

.container-base {
  position: absolute;
  width: 100%;
}

.contador-pag-componentes {
  position: relative;
  z-index: 2000;
  left: 0;
}

.template-pagina-comp {
  height: 70.125rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.container-principal-componentes {
  position: relative;
  z-index: 1;
}

.titulo-componentes {
  margin-top: 4rem;
}

.container-componentes {
  height: auto;
  width: 99.25%;
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.2rem;
  row-gap: 1.5rem;
  margin-top: 2.5rem;
}

.box-componente {
  min-height: 25rem;
  width: 22.2rem; 
  background-color: #F9F9F9;
  display: flex;
  flex-direction: column;
  row-gap: 0.2rem;
  padding: 1rem 1rem 0.5rem;
  border-radius: 0.5rem;
}
.box-comp-espacamento {
  margin-top: 5rem;
}

.imagem-numero-nome-componente {
  display: flex;
  column-gap: 1rem;
}
.img-componente {
  height: 2.5rem;
  width: auto;
}
.numero-nome-componente .titulo-conteudo-detalhes {
  margin-top: 0;
}
.numero-componente {
  color: #4f2c19;
}

.box-componente .grupo-componentes {
  display: grid;
  grid-template-columns: repeat(2, minmax(4rem, 1fr));
  grid-auto-rows: auto;
  gap: 0.5rem 0.2rem;
}
.grupo-componentes .componentes-medidas { grid-area: 1 / 1 / 2 / 2; }
.grupo-componentes .componentes-cor-frente { grid-area: 2 / 1 / 3 / 2; }
.grupo-componentes .componentes-cor-verso { grid-area: 2 / 2 / 3 / 3; }
.grupo-componentes .componentes-acabFrente { grid-area: 3 / 1 / 4 / 2; }
.grupo-componentes .componentes-acabVerso { grid-area: 3 / 2 / 4 / 3; }
.grupo-componentes .componentes-material { grid-area: 4 / 1 / 5 / 2; }
.grupo-componentes .componentes-onda { grid-area: 4 / 2 / 5 / 3; }
.grupo-componentes .componentes-capaExt { grid-area: 5 / 1 / 6 / 2; }
.grupo-componentes .componentes-capaInt { grid-area: 5 / 2 / 6 / 3; }
.grupo-componentes .componentes-papelOnda { grid-area: 6 / 1 / 7 / 2; }
.grupo-componentes .componentes-embalagem-coletiva { grid-column: 1 / 3; }

.grupo-infoBasicas {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: 2rem 3rem;
}
.infoBasicas-amostraRef { grid-area: 2 / 1 / 3 / 2; }
.infoBasicas-observacao { grid-area: 2 / 2 / 3 / 3; }

.box-infoBasicas {
  grid-area: 1 / 1 / 2 / 3;
  background-color: #F9F9F9;
  width: 45.5rem;
  display: grid;
  grid-template-columns: repeat(2, minmax(auto, 1fr));
  grid-auto-rows: auto;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
}

.nome-quantidade-produto {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 1rem;
}

.label-infoBasicas {
  margin-top: 0.5rem;
}

.infoBasicas-quantidade-data {
  display: grid;
  grid-template-columns: repeat(2, minmax(auto, 1fr));
  grid-auto-rows: auto;
}

.ilustracao-sem-imagem {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 0.5rem;
}

.img-sem-imagem {
  height: 7rem;
  width: 6rem;
}

.label-sem-ilustracao {
  color: #A39188;
  font-size: 0.8rem;
  font-family: 'MontSerrat';
  font-weight: 600;
}

.label-infoBasicas2 {
  margin-bottom: 0.5rem;
}

.checkbox-filtros {
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
}

.label-checkbox {
  font-size: 0.8rem;
}

.grupo-demaisCaract {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  grid-auto-rows: auto;
  column-gap: 1rem;
  row-gap: 2rem;
}
.demaisCaract-papel-seda { grid-area: 1 / 1 / 2 / 2; }
.demaisCaract-gerais { grid-area: 2 / 1 / 3 / 2; }
.demaisCaract-embalagem { grid-area: 1 / 2 / 3 / 3; }
.demaisCaract-critica { grid-area: 3 / 1 / 4 / 3; }

.demaisCaract-critica .label-checkbox {
  margin-left: 0;
}

.demaisCaract-gerais .titulo-conteudo-detalhes, 
.demaisCaract-embalagem .titulo-conteudo-detalhes,
.demaisCaract-critica .titulo-conteudo-detalhes {
  margin-bottom: 0.45rem;
}

.critica-container {
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
}

.critica-bool {
  color: #F9F9F9;
  width: max-content;
  padding: 0.2rem 1rem;
  border-radius: 0.2rem;
}

.botao-positivo {
  background-color: #3dca55;
}
.botao-negativo {
  background-color: #DC4242;
}

.grupo-info-orcamentos {
  margin-top: 4rem;
}

.titulo-infoBasicas,
.titulo-demaisCaract, 
.titulo-orcamentos {
  margin-bottom: 1.5rem;
}

.grupo-orcamento {
  display: grid;
  grid-template-columns: 1fr 1.2fr 1fr;
  grid-auto-rows: auto;
  padding: 0 0.9rem;
}
.orcamento-porcentagem-financeira { grid-area: 1 / 1 / 2 / 2; }
.orcamento-forma-pagamento { grid-area: 1 / 2 / 2 / 3; }
.orcamento-data-hora { grid-area: 1 / 3 / 2 / 4; }
.orcamento-prazo-maximo { grid-area: 2 / 1 / 3 / 2; }
.orcamento-gramatura { grid-area: 2 / 2 / 3 / 3; }

.orcamento-tabela {
  width: 45.5rem;
  background-color: #F9F9F9;
  padding: 2rem 1rem;
  border-radius: 0.5rem;
  margin-top: 2rem;
}

.cabecalho-tabela, .info-conteudo {
  display: grid;
  grid-template-columns: repeat(3, minmax(4rem, 1fr));
  grid-auto-rows: auto;
  align-items: center;
  justify-items: center;
}

.titulo-tabela {
  padding-bottom: 1rem;
}

.info-conteudo {
  padding: 0.3rem 0;
}

.info-conteudo .label-conteudo {
  color: #4D4D4D;
  margin-bottom: 0;
}

.pinta-linha {
  background-color: #E3E3E3;
}

.nao-pinta-linha {
  background-color: transparent;
}

.container-demaisCaract-infoBasicas {
  display: flex;
  flex-direction: column;
  row-gap: 3.5rem;
}

.container-infoBasicas {
  position: relative;
}
</style>